import { __awaiter } from "tslib";
import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4cf2170a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { name: "list-plan" };
const _hoisted_2 = {
    key: 0,
    class: "crypto-plan-card"
};
const _hoisted_3 = { class: "crypto-plan-header" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "crypto_icon shidden" }, ".", -1));
const _hoisted_5 = { class: "crypto-is" };
const _hoisted_6 = { class: "crypto-is" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", { class: "clear-ele" }, null, -1));
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
    key: 0,
    class: "overlay"
};
const _hoisted_10 = {
    key: 1,
    class: "crypto-choice-card empty-list"
};
import CryptoPlanCard from '@/materials/molecules/CryptoPlanCard.vue';
import { useMessage } from '@/const/messages';
import { useStaking } from '@/logics/staking';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        cryptoInfo: null,
        isAuth: { type: Boolean }
    },
    emits: ["click"],
    setup(__props, { emit }) {
        return __awaiter(this, void 0, void 0, function* () {
            let __temp, __restore;
            const props = __props;
            const lists = ref();
            const { CHOICECARD, PLANCARD, format } = useMessage();
            const { getStakingPlanListsByCurrency, getStakingPlanListsByCurrencyUnlogin } = useStaking();
            if (props.isAuth) {
                lists.value = (([__temp, __restore] = _withAsyncContext(() => getStakingPlanListsByCurrency(props.cryptoInfo.id))),
                    __temp = yield __temp,
                    __restore(),
                    __temp);
            }
            else {
                lists.value = (([__temp, __restore] = _withAsyncContext(() => getStakingPlanListsByCurrencyUnlogin(props.cryptoInfo.id))),
                    __temp = yield __temp,
                    __restore(),
                    __temp);
            }
            const onClickPlan = (plan) => {
                if (!plan.isStaking && plan.maxInterestRate && plan.minInterestRate) {
                    emit('click', plan);
                }
            };
            return (_ctx, _cache) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (lists.value.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _hoisted_4,
                                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(format)(_unref(PLANCARD).RATE)), 1),
                                _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(format)(_unref(PLANCARD).PERIOD)), 1)
                            ]),
                            _hoisted_7,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lists.value, (list) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: list.term,
                                    class: _normalizeClass(["card", { hoverable: !list.isStaking, 'is-disabled': !list.maxInterestRate && !list.minInterestRate }]),
                                    onClick: ($event) => (onClickPlan(list))
                                }, [
                                    _createVNode(CryptoPlanCard, {
                                        "crypto-name": props.cryptoInfo.cryptoName,
                                        term: list.term,
                                        "max-interest-rate": list.maxInterestRate,
                                        "min-interest-rate": list.minInterestRate
                                    }, null, 8, ["crypto-name", "term", "max-interest-rate", "min-interest-rate"]),
                                    (list.isStaking)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(format)(_unref(PLANCARD).ON_STAKE)), 1))
                                        : _createCommentVNode("", true)
                                ], 10, _hoisted_8));
                            }), 128))
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("p", null, _toDisplayString(_unref(format)(_unref(CHOICECARD).EMPTY)), 1)
                        ]))
                ]));
            };
        });
    }
});
